import React from "react";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../../../utils/commonfunction";

function CategorySelect({ data = [], value, onChange }) {
  const { t } = useTranslation();

  return (
    <div className="form-group mb-0 filter_icon_container filter_design">


      <div className="select-down-arrow">
        <select className="form-control cp" value={value} onChange={(e) => onChange(e.target.value)}>
          <option value="">{t("Select Type")}</option>

          {data.length > 0 &&
            data.map((item) => (
              <option key={item._id} value={item._id}>
                {capitalizeFirstLetter(item.title)}
              </option>
            ))}
        </select>
      </div>
    </div>
  );
}

export default CategorySelect;
